/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * Generates the theme object for the component from the theme and provided additional information
 * @param  {Object} theme The actual theme object.
 * @return {Object} The final theme object with the overrides and component variables
 */
const generateComponentTheme = theme => {
  var _colors$contrasts, _colors$contrasts2, _colors$contrasts3;
  const typography = theme.typography,
    colors = theme.colors,
    borders = theme.borders,
    themeName = theme.key;
  const themeSpecificStyle = {
    canvas: {
      color: theme['ic-brand-font-color-dark'],
      focusOutlineColor: theme['ic-brand-primary']
    }
  };
  const componentVariables = {
    fontSize: typography === null || typography === void 0 ? void 0 : typography.fontSizeMedium,
    fontFamily: typography === null || typography === void 0 ? void 0 : typography.fontFamily,
    fontWeight: typography === null || typography === void 0 ? void 0 : typography.fontWeightNormal,
    lineHeight: typography === null || typography === void 0 ? void 0 : typography.lineHeight,
    color: colors === null || colors === void 0 ? void 0 : (_colors$contrasts = colors.contrasts) === null || _colors$contrasts === void 0 ? void 0 : _colors$contrasts.grey125125,
    background: colors === null || colors === void 0 ? void 0 : (_colors$contrasts2 = colors.contrasts) === null || _colors$contrasts2 === void 0 ? void 0 : _colors$contrasts2.white1010,
    borderColor: colors === null || colors === void 0 ? void 0 : (_colors$contrasts3 = colors.contrasts) === null || _colors$contrasts3 === void 0 ? void 0 : _colors$contrasts3.grey3045,
    borderWidth: borders === null || borders === void 0 ? void 0 : borders.widthSmall,
    borderStyle: borders === null || borders === void 0 ? void 0 : borders.style,
    defaultOverflowY: 'auto',
    focusOutlineColor: colors.contrasts.blue4570
  };
  return {
    ...componentVariables,
    ...themeSpecificStyle[themeName]
  };
};
export default generateComponentTheme;